module.exports = __webpack_public_path__ + "static/img/icon-match-upload-result.9993956b.png";